import { withStyles } from "@mui/styles";
import { ReactNode } from "react";

const styles = function styles() {
  return {
    "@global": {
      "*, *::before, *::after": {
        boxSizing: "inherit",
      },
      html: {
        boxSizing: "border-box",
      },
    },
  };
};

function CssBaseline({ children }: { children?: ReactNode }) {
  return <>{children}</>;
}

export default withStyles(styles, {
  name: "CssBaseline",
})(CssBaseline);
